<template>
  <div class="fw-winners">
    <div class="fw-winners-wrap">
      <table class="fw-table">
        <thead>
        <tr>
          <th>#</th>
          <th>FW#</th>
          <th>Win Date</th>
          <th>Win $</th>
          <th>Winner Name</th>
          <th>Winner Phone</th>
          <th>Instagram</th>
          <th>Shop Name</th>
          <th>Payment Method</th>
          <th>Payment Handle</th>
          <th class="paid-col">Paid Date</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="winner in frootwheel_winner_data" v-bind:key="winner.identification_number">
          <td>{{winner.count}}</td>
          <td>{{winner.identification_number}}</td>
          <td class="nowrap">{{winner.finishdate}}</td>
          <td class="nowrap">${{winner.win_dollar}}</td>
          <td>{{winner.name}}</td>
          <td class="nowrap">{{winner.phone}}</td>
          <td>{{winner.instagram}}</td>

          <td>
            <input
                type="text"
                id="shop_name_2"
                :value="winner.shop_name"
                @input="winner.shop_name = $event.target.value"
                @blur="set_frootwheel_field(winner.identification_number,'shop_name',winner.shop_name)">
          </td>

          <td>
            <input
                type="text"
                id="payment_method"
                :value="winner.payment_method"
                @input="winner.payment_method = $event.target.value"
                @blur="set_frootwheel_field(winner.identification_number,'payment_method',winner.payment_method)">
          </td>

          <td>
            <input
                type="text"
                id="payout_handle"
                :value="winner.payout_handle"
                @input="winner.payout_handle = $event.target.value"
                @blur="set_frootwheel_field(winner.identification_number,'payout_handle',winner.payout_handle)">
          </td>

          <td class="paid-col" v-if="winner.payment_sent.length === 0">
            <button type="button" class="paid-btn" v-on:click="set_frootwheel_field(winner.identification_number,'payment_sent','button')">Mark as paid</button>
          </td>
          <td class="paid-col nowrap" v-else>
            {{winner.payment_sent}}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      frootwheel_winner_data: 'admin/frootwheel_winner_data',
    }),
  },
  mounted() {
    this.get_frootwheel_winners();
  },
  methods: {
    set_frootwheel_field (id,fieldname,value) {
      let origin = 3;
      this.$store.dispatch('admin/setFrootWheelField', {id,fieldname,value,origin})
    },
    get_frootwheel_winners () {
      this.$store.dispatch('admin/frootWheelWinners' );
    },
  }
}
</script>

<style scoped>
.fw-winners {
  padding: 10px;
  box-sizing: border-box;
}
.fw-winners-wrap {
  overflow-x: auto;
}
.fw-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 1.2;
  color: #1a3038;
  background: #fff;
  border: 1px solid #d7e0e4;
}
.fw-table th,
.fw-table td {
  padding: 7px 8px;
  border: 1px solid #d7e0e4;
  vertical-align: middle;
  text-align: left;
}
.fw-table thead th {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #5d727a;
  background: #f4f7f8;
  white-space: nowrap;
}
.fw-table tbody tr:nth-child(even) {
  background: #fafcfd;
}
.fw-table tbody tr:hover {
  background: #eef5f7;
}
.nowrap {
  white-space: nowrap;
}
.paid-col {
  width: 1%;
  white-space: nowrap;
  text-align: center;
  padding-left: 8px;
  padding-right: 8px;
}
.fw-table input[type="text"] {
  display: block;
  width: 100%;
  max-width: 160px;
  box-sizing: border-box;
  height: 30px;
  padding: 0 8px;
  border: 1px solid #cfd8dc;
  border-radius: 6px;
  background: #fff;
  font: inherit;
  font-size: 16px;
  color: #1a3038;
}
.fw-table input[type="text"]:focus {
  outline: none;
  border-color: #7eb7c6;
}
.paid-btn {
  display: inline-block;
  box-sizing: border-box;
  width: auto;
  height: 30px;
  line-height: 28px;
  padding: 0 10px;
  border: 1px solid #16343d;
  border-radius: 6px;
  background: #16343d;
  color: #fff;
  font: inherit;
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}
.paid-btn:hover {
  background: #0f262c;
}
</style>
